module.exports = __webpack_public_path__ + "static/media/solomon-russell.e6f61a67.jpeg";